import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import { CalendarPlanningHeader } from './components/calendar-planning-header';
import { CalendarJobType } from './components/calendar-job-type';
import { CalendarDepartment } from './components/calendar-department';

type CalendarShiftProps = {
  data: {
    id: string;
    name: string;
    jobTypes: {
      id: string;
      name: string;
      shifts: {
        applicants: number;
        claimants: number;
        jobName: string;
        flexPoolOnly: boolean;
        dateLabel: string;
        dateTime: string;
        endTime: string;
        id: string;
        maxClaimants: number;
        startTime: string;
        hasPartners: boolean;
        hasCanceledClaim: boolean;
      }[];
    }[];
  }[];
  onScroll?: (element?: HTMLDivElement | null | undefined) => void;
};

export const CalendarShift = ({ data, onScroll }: CalendarShiftProps) => {
  const { t } = useTranslation('ogp-screen-specific');
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (onScroll) {
      onScroll(containerRef.current);
    }
  }, [onScroll]);

  if (data.length === 0) {
    return (
      <StyledNoResultsBox>
        <StyledMessage variant="h2">{t('planning.calendar.no_shifts_title')}</StyledMessage>
        <Typography>{t('calendar.no-shifts-message')}</Typography>
      </StyledNoResultsBox>
    );
  }

  return (
    <>
      <CalendarPlanningHeader />
      <StyledContainer
        ref={containerRef}
        onScroll={onScroll ? (e) => onScroll(e.target as HTMLDivElement) : () => {}}
      >
        <CalendarJobType jobType={undefined} />
        {data.map((dpt) => (
          <CalendarDepartment key={dpt.id} department={dpt} />
        ))}
      </StyledContainer>
    </>
  );
};

const StyledContainer = styled(Box)({
  overflowY: 'auto',
  maxHeight: '100%',
});

const StyledNoResultsBox = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  flex: '1 1 100%',
  '& *': {
    textAlign: 'center',
    maxWidth: theme.spacing(120),
  },
}));

const StyledMessage = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  marginTop: theme.spacing(24),
  marginBottom: theme.spacing(8),
}));
